/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { CallParkingProvider } from '../hooks/use-call-parking';
import { KazooProvider } from '../hooks/use-kazoo';
import { PhoneProvider, PhoneWarningsProvider } from '../hooks/use-phone';
import { PhoneEventHandlerProvider } from '../hooks/use-phone-event-handler/provider';
import PhoneWidgetPropsProvider from '../hooks/use-phone-widget-props/provider';
import PhoneWidgetProvider from '../hooks/use-phone-widget/provider';
import { PhoneLockProvider } from '../hooks/use-phone-lock/provider';
import PhoneActionsProvider from '../hooks/use-phone-actions/provider';
import { ScreenPopProvider } from '../hooks/use-screen-pop/providers';

interface PhoneWidgetProvidersProps {
  children: React.ReactNode;
}

export const PhoneWidgetProviders: React.FC<PhoneWidgetProvidersProps> = (props) => {
  return (
    <PhoneWidgetPropsProvider>
      <KazooProvider>
        <PhoneLockProvider>
          <PhoneProvider>
            <ScreenPopProvider>
              <CallParkingProvider>
                <PhoneWarningsProvider>
                  <PhoneActionsProvider>
                    <PhoneEventHandlerProvider>
                      <PhoneWidgetProvider>{props.children}</PhoneWidgetProvider>
                    </PhoneEventHandlerProvider>
                  </PhoneActionsProvider>
                </PhoneWarningsProvider>
              </CallParkingProvider>
            </ScreenPopProvider>
          </PhoneProvider>
        </PhoneLockProvider>
      </KazooProvider>
    </PhoneWidgetPropsProvider>
  );
};
